/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import {
  StyledEngineProvider, ScopedCssBaseline, ThemeProvider, Container, Box, Typography,
} from '@mui/material';

import theme from '../../CoachTools/layout/theme';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { ListItem } from './styles';

const InstagramPrivacyPolicy = () => (
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={theme}>
      <ScopedCssBaseline>
        <Container sx={{ pt: 4 }}>
          <Typography component="h1" variant="h3">
            Privacy Policy for the Avida Instagram App
          </Typography>

          <Box sx={{ mt: 3 }}>
            <Typography variant="subtitle1">Effective Date: 09-April-2025</Typography>
            <p>
              {`Avida ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how
              our Meta-integrated application ("the App") collects, uses, stores, and deletes your Instagram data in
              compliance with Meta's platform policies and applicable data protection laws.`}
            </p>
          </Box>

          <Box>
            <ol>
              <ListItem>
                <Typography component="h2" variant="h5">
                  Information We Collect
                </Typography>
                <p>
                  When you connect your Instagram account to our App via Meta&apos;s authentication flow, we collect the
                  following <strong>publicly available Instagram data:</strong>
                </p>
                <ul>
                  <li>
                    <strong>Public Instagram posts:</strong> Captions, images, and videos
                  </li>
                  <li>
                    <strong>Profile information:</strong> Username and bio
                  </li>
                </ul>
              </ListItem>
              <ListItem>
                <Typography component="h2" variant="h5">
                  How We Use the Information
                </Typography>
                <p>We use your Instagram data to:</p>
                <ul>
                  <li>Attribute your content within our internal Avida dashboard</li>
                  <li>Display it within our coaching tools to help you analyze engagement and content performance</li>
                  <li>Generate insights to help you improve coach-client interactions and plan future content</li>
                </ul>
                <p>
                  We do <strong>not</strong> sell or share your data with any third parties.
                </p>
              </ListItem>

              <ListItem>
                <Typography component="h2" variant="h5">
                  Data Storage & Retention
                </Typography>
                <ul>
                  <li>
                    <strong>Storage:</strong> Your Instagram data is stored securely in our cloud infrastructure and is
                    accessible only to authorized Avida personnel and yourself.
                  </li>
                  <li>
                    <strong>Retention:</strong> We retain your data only as long as necessary to provide services to
                    you. Your data will be{' '}
                    <strong>automatically deleted once the App is deauthorized via Instagram,</strong> which triggers a
                    webhook to remove your stored data from our system.
                  </li>
                </ul>
              </ListItem>

              <ListItem>
                <Typography component="h2" variant="h5">
                  Data Deletion Requests
                </Typography>
                <p>
                  You can request deletion of your Instagram data at any time by contacting us at{' '}
                  <strong>hello@avida.life.</strong>
                  <br />
                  Once we receive your request, we will delete all associated Instagram data within{' '}
                  <strong>7 business days.</strong>
                </p>
              </ListItem>
              <ListItem>
                <Typography component="h2" variant="h5">
                  Data Security
                </Typography>
                <p>
                  We use industry-standard security measures to protect your Instagram data from unauthorized access,
                  disclosure, or destruction. These include:
                </p>
                <ul>
                  <li>Encrypted data storage</li>
                  <li>Secure API communication</li>
                  <li>Role-based access controls</li>
                </ul>
              </ListItem>
              <ListItem>
                <Typography component="h2" variant="h5">
                  Children&apos;s Privacy
                </Typography>
                <p>
                  This App is not intended for individuals under the age of 13. We do not knowingly collect or store any
                  data from users under this age.
                </p>
              </ListItem>
              <ListItem>
                <Typography component="h2" variant="h5">
                  Updates to This Policy
                </Typography>
                <p>
                  We may update this Privacy Policy to reflect changes in our data practices. Any updates will be posted
                  here, and if significant, we’ll notify you via email or in-app notification.
                </p>
              </ListItem>
              <ListItem>
                <Typography component="h2" variant="h5">
                  Contact Us
                </Typography>
                <p>
                  If you have any questions about this Privacy Policy or how we handle your data,
                  {' '}
                  please contact us at:
                  {' '}
                  <strong>hello@avida.life</strong>
                </p>
              </ListItem>
            </ol>
          </Box>
        </Container>
      </ScopedCssBaseline>
    </ThemeProvider>
  </StyledEngineProvider>
);

export default InstagramPrivacyPolicy;
